var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLampOn2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C21.523 9 26 13.477 26 19C26 24.523 21.523 29 16 29C10.477 29 6 24.523 6 19C6 13.477 10.477 9 16 9ZM16 12C12.134 12 9 15.134 9 19C9 22.866 12.134 26 16 26C19.866 26 23 22.866 23 19C23 15.134 19.866 12 16 12ZM12 3C13.105 3 14 3.895 14 5C14 6.105 13.105 7 12 7C10.895 7 10 6.105 10 5C10 3.895 10.895 3 12 3ZM20 3C21.105 3 22 3.895 22 5C22 6.105 21.105 7 20 7C18.895 7 18 6.105 18 5C18 3.895 18.895 3 20 3Z",
    fill: "url(#hinava_random_uuid_36234942931309147656734345927709194191)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C21.523 9 26 13.477 26 19C26 24.523 21.523 29 16 29C10.477 29 6 24.523 6 19C6 13.477 10.477 9 16 9ZM16 12C12.134 12 9 15.134 9 19C9 22.866 12.134 26 16 26C19.866 26 23 22.866 23 19C23 15.134 19.866 12 16 12ZM12 3C13.105 3 14 3.895 14 5C14 6.105 13.105 7 12 7C10.895 7 10 6.105 10 5C10 3.895 10.895 3 12 3ZM20 3C21.105 3 22 3.895 22 5C22 6.105 21.105 7 20 7C18.895 7 18 6.105 18 5C18 3.895 18.895 3 20 3Z",
    fill: "url(#hinava_random_uuid_172644546211638082163658693285566738979)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_36234942931309147656734345927709194191",
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_172644546211638082163658693285566738979",
    x1: 16,
    y1: 3,
    x2: 16,
    y2: 29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampOn2);
export default __webpack_public_path__ + "static/media/lamp-on-2.57bfebe26e900cd5c900b60a2f66ae55.svg";
export { ForwardRef as ReactComponent };